import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import CompanionILECard from "../CompanionILECard/CompanionILECard";
import type { CompanionILECardProps } from "../CompanionILECard/CompanionILECard";
import { spacing } from "../../../styles/design-system";

export interface CompanionILECardListProps {
  activities: CompanionILECardProps[];
  scrollable?: boolean;
  containerStyle?: object;
}

const CompanionILECardList: React.FC<CompanionILECardListProps> = ({
  activities,
  scrollable = false,
  containerStyle = {},
}) => {
  const content = (
    <View style={[styles.gridContainer, containerStyle]}>
      {activities.map((activity) => (
        <View key={activity.id} style={styles.cardWrapper}>
          <CompanionILECard {...activity} />
        </View>
      ))}
    </View>
  );

  if (scrollable) {
    return (
      <ScrollView style={styles.scrollContainer} contentContainerStyle={styles.scrollContent}>
        {content}
      </ScrollView>
    );
  }

  return content;
};

const styles = StyleSheet.create({
  scrollContainer: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
  },
  gridContainer: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: spacing.sm,
    padding: spacing.sm,
  },
  cardWrapper: {
    width: 400,
    flexShrink: 0,
    flexGrow: 0,
  },
});

export default CompanionILECardList;
